import {Button, MenuItem, TextField} from "@mui/material";
import {useState} from "react";
import {useAsyncAction} from "nate-react-api-helpers";
import {SmoothLoader} from "../../../../../misc/Loader";
import {useSyncedRef} from "../../../../../misc/SyncedRef";
import {intOrNull} from "../../freeformchanges/products/add/ConfigureDegreesOfOpening";

export type BulkTarget = "active" | "inactive" | "both";

export function BulkAssignDegrees(props: {
    isPair: boolean;
    onSubmit(input: {value: number | null, target: BulkTarget}): Promise<any>;
}) {
    const [value, setValue] = useState("");
    const [target, setTarget] = useState<BulkTarget>("active");

    const onSubmitRef = useSyncedRef(props.onSubmit);
    const submit = useAsyncAction(async (input: {value: number | null, target: BulkTarget}) => {
        await onSubmitRef.current(input);
        setValue("");
        setTarget("active");
    }, []);

    return (
        <>
            <div style={{
                display: "flex",
                gap: 8,
                padding: 8,
                alignItems: "center",
            }}>
                <TextField
                    label="Degrees"
                    size="small"
                    style={{width: 90}}
                    value={value}
                    onChange={e => setValue(e.currentTarget.value.replace(/[^0-9]+/g, ""))}
                />
                {props.isPair && <TextField
                    select
                    label="Assign"
                    size="small"
                    style={{width: 110}}
                    value={target}
                    onChange={e => setTarget(e.target.value as BulkTarget)}
                >
                    <MenuItem value="active">Active</MenuItem>
                    <MenuItem value="inactive">In-Active</MenuItem>
                    <MenuItem value="both">Both</MenuItem>
                </TextField>}
                <Button
                    size="small"
                    variant="outlined"
                    disabled={submit.loading}
                    onClick={() => submit.callback({
                        value: intOrNull(value),
                        target: props.isPair ? target : "active",
                    })}
                >
                    Apply to All
                </Button>
            </div>
            <SmoothLoader loading={submit.loading} error={submit.error} />
        </>
    )
}
